import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { nameof } from '../../utils/object';
import { OrderDefinition } from 'stores/dataStore';
import { RejectReasonDto, RejectReasonsStore } from 'stores/configuration/events-n-requests/rejection-reasons-store';
import TailwindSelect from 'widgets/editors/tailwind-select';

interface TailwindRejectReasonComponentProps extends WithTranslation {
  value: string;
  onChange: (value: any) => void;
  placeholder?: string;
  clearable?: boolean;
  rejectReasonsStore?: RejectReasonsStore;
  readOnly?: boolean;
  className?: string;
}

interface TailwindRejectReasonComponentState {
  rejectReasons: { text: string; value: string }[];
  isLoading: boolean;
}

@connect(['rejectReasonsStore', RejectReasonsStore])
class TailwindRejectReasonComponent extends Component<TailwindRejectReasonComponentProps, TailwindRejectReasonComponentState> {
  private get rejectReasonsStore() {
    return this.props.rejectReasonsStore;
  }

  state: TailwindRejectReasonComponentState = { isLoading: false, rejectReasons: [] };

  componentDidMount() {
    this.loadRejectReasonsStore();
  }

  private loadRejectReasonsStore = async () => {
    try {
      this.setState({ isLoading: true });
      const filter = [];

      const orderBy: OrderDefinition[] = [{ direction: 'Ascending', field: nameof<RejectReasonDto>('name'), useProfile: false }];

      return await this.rejectReasonsStore
        .getAllAsync({ searchQuery: '', skip: 0, take: 100000, orderBy, filter })
        .then(rejectReasonsStore => {
          const options = [];
          rejectReasonsStore.items.forEach(rejectReason => options.push({ text: rejectReason.name, value: rejectReason.id }));
          this.setState({ rejectReasons: options });
        });
    } catch (error) {
      console.error('Error loading locations:', error);
      this.setState({ rejectReasons: [] });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  // private handleOnChange = (_, { value }: DropdownProps) => {
  //   this.props.onChange(value as string);
  // };

  private handleOnChange = (newValue: string | null) => {
    const selected = newValue ? this.state.rejectReasons.find(opt => opt.value === newValue) : null;
    const itemRef = selected ? { id: selected.value, title: selected.text } : null;
    this.props.onChange?.(itemRef);
  };

  public render() {
    const { rejectReasons, isLoading } = this.state;
    //const { t, readOnly, error, className, loading, value, placeholder, rejectReasonsStore } = this.props;
    const { t, readOnly, value, placeholder } = this.props;
    return (
      <>
        <TailwindSelect
          options={
            isLoading
              ? [{ id: 'loading', text: t('Loading...'), disabled: true }]
              : rejectReasons.length > 0
              ? rejectReasons.map(reason => ({
                  id: reason.value,
                  text: reason.text
                }))
              : [{ id: 'no-options', text: t('No options available'), disabled: true }]
          }
          value={value || ''}
          onChange={this.handleOnChange}
          placeholder={placeholder || t('Select Reject Reason')}
          clearable
          searchable={!isLoading}
          className="w-full"
          disabled={readOnly}
        />
      </>
    );
  }
}

export default withTranslation()(TailwindRejectReasonComponent);
